import { default as React } from 'react';
import MedicationList from '../../Images/no-medication-list.svg';
import styles from './NoMedicationList.module.css';
export var NoMedicationList = function (props) {
    return (React.createElement("div", { className: styles.placeholder },
        React.createElement("div", { className: styles.placeholderContent },
            React.createElement("img", { src: MedicationList, alt: 'nothing-found' }),
            React.createElement("div", { className: styles.placeholderTitleText }, props.title),
            props.info && React.createElement("div", { className: styles.placeholderText }, props.info))));
};
